export const ru =
{
  Message:
  {
    // Сообщения для всех компонентов
  },
  Locale:
  {
    true: "Да",
    false: "Нет",
    error:
      "{message}",
    invalid:
      "Обратитесь в службу поддержки. Произошла ошибка при использовании {component}. Некорректное значение {name}: {value}",
    assert:
      "Обратитесь в службу поддержки. Произошла внутренняя ошибка {component} {data}",
  },
  LocaleSample:
  {
    test1: "Тестовое сообщение",
    test2: "Тестовое сообщение с подстановкой параметров: локализованное число {n}; локализованное время {time}; подстановка строки без локализации {str}",
    text_data: "Текстовые данные",
    error1: "Пример сообщения об ошибке пользователя",
    error2: "Пример сообщения об ошибке валидации данных или состояния",
    error3: "Пример сообщения о внутренней ошибке компонента"
  },
  Config:
  {
    load_error:
      "Произошла ошибка при загрузке файла конфигурации: {message}",
  },
};
